<div class="form-container">
  <label class="custom-dropdown-label">{{label}} <span *ngIf="this.required">*</span></label>
  <angular2-multiselect *ngIf="!isOpen" [data]="choices" [ngModelOptions]="{ standalone: true }" [(ngModel)]="selected"
    [settings]="settings" (onSelect)="formChanged($event)" (onDeSelect)="formChanged($event)"
    (onSelectAll)="formChanged($event)" (onDeSelectAll)="deselectAll()" (onOpen)="open()">
  </angular2-multiselect>

  <mat-form-field *ngIf="isOpen" appearance="outline">
    <mat-label>{{label}}</mat-label>
    <mat-select #oldSelect name="selected" [(ngModel)]="selectedOld" (openedChange)="closed($event)" [multiple]="true"
      (selectionChange)="oldChange()">
      <ng-form novalidation>
        <div class=" recpient-container">
          <mat-form-field appearance="standard">
            <mat-label>Recipient</mat-label>
            <input type="email" #Recipient="ngModel" name="recipient" [(ngModel)]="tempRecipient" matInput
              placeholder="Recipient" pattern="^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$" />

            <!-- pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z0-9]{2,}" -->
            <mat-error *ngIf="!tempRecipient ||  tempRecipient.length === 0 || Recipient.errors">Email must be
              a valid email address</mat-error>
          </mat-form-field>
          <div>
            <button (click)="addRecipient()"
              [disabled]="Recipient.invalid || !tempRecipient || tempRecipient?.length === 0" mat-raised-button
              color="primary">Add</button>
          </div>
        </div>
      </ng-form>
      <mat-option [value]="" disabled>Selected Addresses</mat-option>
      <mat-option *ngFor="let opt of choices" [value]="opt.id">{{opt.itemName}}</mat-option>

    </mat-select>
  </mat-form-field>
  <mat-error *ngIf="touched && required && (!selected || selected.length === 0)">Field is required</mat-error>

</div>
